import Util from "../common/Util.js";
import Common from "../common/CommonNctv";
import SearchAbsList, {SEARCH_PARAM} from "../common/list/SearchAbsList";
import Tab from "../common/Tab";

//녹명촌, 린검사,
class App {
  constructor(_option) {
    this.apiDomain = _option.apiDomain;
    this.com = Common.instance;
    this.com.init();
    this.container = ".search .cards";
    this.keyword = Util.getParamByName(SEARCH_PARAM.KEYWORD) || "";
    this.videoKind = Util.getParamByName(SEARCH_PARAM.VIDEO_KIND) || "";
    this.sort = Util.getParamByName(SEARCH_PARAM.SORT) || "";
    this.field = Util.getParamByName(SEARCH_PARAM.FIELD) || "";
    this.addElements();
    this.addEvents();
    this.init();
  }

  init() {
    this.list = new SearchAbsList(
      {
        apiDomain: this.apiDomain,
        order: this.sort,
        query: this.keyword,
        videoKind: this.videoKind,
        filter: this.field
      },
      "search",
      this.container
    );

    $(`[data-videoKind="${this.videoKind}"]`).addClass("is-active"); //탭 확성화
    this.tab = new Tab(".search .tab"); //탭 스크롤여부
    this.setNcuiAutoSugget();
  }

  goSearch(_key = SEARCH_PARAM.KEYWORD, _val = this.keyword) {
    const q = encodeURIComponent(this.keyword);
    const url = Util.addParam(SEARCH_PARAM.KEYWORD, q);
    window.location.href = Util.addParam(_key, _val, url);
  }

  //검색결과 없음 화면
  toggleEmpty(contentSize) {
    if (!contentSize) {
      this.el.emptyWrap.css("display", "flex");
      this.el.resultWrap.hide();
    }
  }

  //탭 클릭햇을 때
  clickTab(_e) {
    _e.preventDefault();

    this.videoKind = $(_e.target).attr("data-videoKind");
    this.goSearch(SEARCH_PARAM.VIDEO_KIND, this.videoKind);
  }

  setNcuiAutoSugget() {
    if (window.ncui && window.ncui.autoSuggest) {
      const autoSuggest = new window.ncui.autoSuggest({
        apiUrl: `${this.apiDomain}/${this.com.ip}/search/v2/nctv/suggest`,
        selector: ".search-header-form",
        size: 10,
        useDelbtn: true,
        useRecent: false,
        cookieName: `search-nctv`,
        locale: `ko-KR`,
        keywordParamName: "keyword",
        placeholderStr: "NCTV 통합검색",
        useCookie: true,
        submitCallback: this.clickSubmit.bind(this),
      });

      autoSuggest.value(this.keyword);
    }
  }

  // 검색버튼 이나 엔터 쳤을때
  clickSubmit(keyword) {
    if (keyword) {
      this.keyword = keyword;
      this.goSearch();
    } else {
      alert("검색어를 입력해 주세요");
    }
  }

  // 데이터 로딩 끝났을때
  loadData(_e, data) {
    this.toggleEmpty(data.totalCount);
    this.el.totalCount.html(data.totalCount); //검색결과 숫자
  }

  addElements() {
    this.el = {
      tab: $(".search .tab-item"),
      input: $('#autoSuggest [data-name="suggest_input"]'),
      submit: $('[data-name="suggest_submit"]'),
      emptyWrap: $('[data-result="empty"]'),
      resultWrap: $('[data-result="wrap"]'),
      totalCount: $('[data-result="count"]'),
    };
  }

  addEvents() {
    this.el.tab.on("click", (_e) => {
      this.clickTab(_e);
    });
    //this.el.GamelogOption.on('click', (_e) => {this.clickGamelogOption(_e)});
    this.el.submit.on("click", (_e) => {
      this.clickSubmit();
    });
    // this.el.input.on("keyup", (_e) => {
    //   if (_e.keyCode === 13) this.clickSubmit();
    // });
    $(".contents").on("LOAD_LIST_DATA", (_e, data) => {
      this.loadData(_e, data);
    });
  }
}
export default App;

Util.namespace("nc.nctv.search");
nc.nctv.search = App;
